var _mask, _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecondMugAngle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 70,
    viewBox: "0 0 64 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_13046_25425",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 -1.74846e-07C38.2091 -7.8281e-08 40 1.79086 40 4L40 18L24 18L24 4C24 1.79086 25.7909 -6.21101e-07 28 -5.24537e-07L36 -1.74846e-07Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 -4C40.4183 -4 44 -0.418278 44 4L44 19L36 17L36 4L36 -4ZM20 19L20 4C20 -0.418279 23.5817 -4 28 -4L28 4L28 17L20 19ZM20 4C20 -0.418279 23.5817 -4 28 -4L36 -4C40.4183 -4 44 -0.418278 44 4L36 4L28 4L20 4ZM44 19L20 19L28 17L36 17L44 19Z",
    fill: "#CCCCCC",
    mask: "url(#path-1-inside-1_13046_25425)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 40,
    r: 22,
    transform: "rotate(90 32 40)",
    stroke: "#CCCCCC",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 64,
    r: 6,
    fill: "#3D98F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondMugAngle);
export default __webpack_public_path__ + "static/media/second-mug-angle.dec59e77acbc4d0e7f50b7b64691b23c.svg";
export { ForwardRef as ReactComponent };